import React from 'react';
import { Checkbox } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import classNames from 'classnames';
import { Tooltip } from 'components';
import { SelectedTeams, Team } from './teams-section';

interface CheckAllProps {
	element: JSX.Element;
	selectedTeams: SelectedTeams;
	allTeams: Team[];
	setSelectedTeams: (selectedTeams: SelectedTeams) => void;
	disabledTeamIds: Set<string>;
	disabled?: boolean;
}

export const CheckAll: React.FC<CheckAllProps> = ({
	element,
	selectedTeams,
	allTeams,
	setSelectedTeams,
	disabledTeamIds,
	disabled
}) => {
	const isChecked = allTeams.reduce((acc, curr) => {
		return (disabledTeamIds.has(curr.id) || selectedTeams[curr.id]) && acc;
	}, true);

	const onChange = e => {
		const checked = e.target.checked;
		const teams = allTeams.reduce((acc, curr) => {
			const isDisabled = disabledTeamIds.has(curr.id);
			if (!isDisabled) {
				acc[curr.id] = !!checked;
			}
			return acc;
		}, {});
		setSelectedTeams(teams);
	};

	return (
		<div className="team-row">
			<Checkbox className="team-section-checkbox" checked={isChecked} onChange={onChange} disabled={disabled} />
			{element}
		</div>
	);
};
const ConflictRuleRow = (ruleName: string, index: number) => (
	<span className="rule-tag" key={index}>
		{ruleName}
	</span>
);

interface TeamRowProps {
	element: JSX.Element;
	checked: boolean;
	disabled: boolean;
	conflictRules: string[];
	disabledTeamTranslation: string;
	readOnly?: boolean;
	onChange: (e: CheckboxChangeEvent) => void;
}

export const TeamRow: React.FC<TeamRowProps> = ({
	element,
	checked,
	disabled,
	disabledTeamTranslation,
	onChange,
	conflictRules,
	readOnly
}) => {
	const content = (
		<div className={classNames('team-row', { 'team-row-disabled': disabled })}>
			<Checkbox className="team-section-checkbox" checked={checked} onChange={onChange} disabled={readOnly} />
			{element}
			<div>{conflictRules.map(ConflictRuleRow)}</div>
		</div>
	);

	return disabled ? (
		<Tooltip title={disabledTeamTranslation} placement="topLeft">
			{content}
		</Tooltip>
	) : (
		content
	);
};
